import axios from 'axios';

console.log(process.env.NEXT_PUBLIC_API_BASE_URL)
// https://montessori.srshta.com/api
//  const baseURL = 'https://montessori.srshta.com/api';
 const baseURL = process.env.REACT_APP_APIURL;
 // const baseURL = `http://localhost:5057/api`;
// const baseURL = 'http://localhost:5057/api';
const instance = axios.create({
  baseURL:baseURL,
  timeout: 500000,
  headers: {
    Accept: 'application/json',


    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token;
  if ( localStorage.getItem("id_token")) {
    token =   localStorage.getItem("id_token");
  }
  
  // If FormData, don't set Content-Type - let browser set it with boundary
  const isFormData = config.data instanceof FormData;
  
  const headers = { ...config.headers };
  if (token) {
    headers.authorization = `Bearer ${token}`;
  }
  
  // Remove Content-Type for FormData to let browser set it automatically
  if (isFormData) {
    delete headers['Content-Type'];
  }
  
  return {
    ...config,
    headers: headers,
  };
});

// console.log(process.env.API_BASE_URL);
const responseBody = (response) => response.data;

const requests = {
  get: (url, body) => instance.get(url, body).then(responseBody),

  post: (url, body, headers) =>
    instance.post(url, body, headers).then(responseBody),

  put: (url, body) => instance.put(url, body).then(responseBody),
  patch: (url, body) => instance.patch(url, body).then(responseBody),
  delete: (url, body) => instance.delete(url).then(responseBody),
  baseURL:() => baseURL ,
};

export default requests;
